module.exports = __webpack_public_path__ + "img/redwulf-50A.2f4816c3.png";